import { useCallback, useState } from 'react';
import { Button } from 'components/core/button';
import { AppLink } from 'components/core/link/Link';
import { Text } from 'components/core/text/Text';
import { Modal, ModalBody } from 'components/modal/Modal';

export const BCMHelpButton = () => {
  const [helpOpen, setHelpOpen] = useState(false);
  const onClickHelpModal = useCallback(() => {
    setHelpOpen(true);
  }, []);
  const onHelpClose = useCallback(() => {
    setHelpOpen(false);
  }, []);
  return (
    <>
      <AppLink to="" onClick={onClickHelpModal} className="inline-block">
        <Text variant="text4" bold>
          What&apos;s a Behavioral Care Manager?
        </Text>
      </AppLink>
      {helpOpen && (
        <Modal onClose={onHelpClose}>
          <ModalBody
            style={{
              alignItems: 'center',
              gap: '1em',
              maxWidth: '640px',
              textAlign: 'center',
            }}
          >
            <Text variant="heading5">What is a Behavioral Care Manager?</Text>
            <Text variant="text5">
              Your Behavioral Care Manager (BCM) is your team quarterback —
              they&rsquo;ll be with you every step of the way to coordinate care
              for your family, serve as your advocate, and give you updates on
              treatment plans.{' '}
            </Text>
            <Button onClick={onHelpClose}>OK, got it!</Button>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};
